<div class="fullSize flexCenter flexColumn">
  <div class="textDiv">
    <div class="textDiv">
      <p class="fullWidth">You have successfully logged out.</p>
    </div>
  </div>
  <app-login></app-login>
</div>
